import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.user.settings').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.settings, {
    url: 'usersettings',
    params: { title: 'Settings' },
    templateUrl: 'Client/runner.user.settings/runner.user.settings.tmpl.html'
  });
}
